export default function ChevronRLeft() {
    return (
        <svg>
            <use xlinkHref="#chevron-left" />
        </svg>
    );
}
